import { Link } from 'react-router-dom';
import { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  variant?: 'default' | 'horizontal';
}

export default function MovieCard({ movie, variant = 'default' }: MovieCardProps) {
  if (variant === 'horizontal') {
    return (
      <Link
        to={`/detail/${movie.id}`}
        className="flex gap-4 p-3 rounded-lg bg-background-50 hover:bg-background-100 cursor-pointer group transition-all duration-200"
      >
        <div className="w-24 h-32 flex-shrink-0 rounded-lg overflow-hidden">
          <img
            src={movie.coverUrl}
            alt={movie.title}
            title={`${movie.title} - 麻花影院免费观看`}
            className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
          />
        </div>
        <div className="flex flex-col justify-center min-w-0">
          <h4 className="font-heading font-semibold text-foreground-950 text-sm group-hover:text-primary-600 transition-colors line-clamp-1">
            {movie.title}
          </h4>
          <p className="text-xs text-foreground-500 mt-1">{movie.year} / {movie.region}</p>
          <div className="flex items-center gap-2 mt-2">
            <span className="text-xs px-2 py-0.5 rounded-full bg-accent-100 text-accent-800 font-medium">
              {movie.rating}
            </span>
            <span className="text-xs text-foreground-500">{movie.category}</span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/detail/${movie.id}`}
      className="block group cursor-pointer"
    >
      <div className="relative aspect-[2/3] rounded-lg overflow-hidden mb-3">
        <img
          src={movie.coverUrl}
          alt={movie.title}
          title={`${movie.title} - 麻花影院免费观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
        />
        <div className="absolute top-2 right-2 px-2 py-1 rounded-md bg-background-950/70 text-accent-400 text-xs font-bold">
          {movie.rating}
        </div>
        {movie.isNew && (
          <div className="absolute top-2 left-2 px-2 py-1 rounded-md bg-primary-500 text-background-50 text-xs font-medium">
            新
          </div>
        )}
        <div className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-background-950/80 to-transparent p-3 pt-8">
          <p className="text-xs text-background-50/90">{movie.updateInfo}</p>
        </div>
      </div>
      <h3 className="font-heading font-semibold text-foreground-950 text-sm group-hover:text-primary-600 transition-colors line-clamp-1">
        {movie.title}
      </h3>
      <p className="text-xs text-foreground-500 mt-1">
        {movie.year} / {movie.category}
      </p>
    </Link>
  );
}